import React, { useState, useEffect } from "react";
import { Card, FormGroup } from "reactstrap";
import { useCookies } from "react-cookie";
import DatePicker from "react-datepicker";
import moment from "moment";
import { getPermission } from "utils/Utils";
import { getDashboardTicketStatusTotal } from "../../services/dashboard";

const STATUSES = ["UNOPENED", "OPENED", "PENDING", "SOLVED", "RESOLVED"];

// Live Chat tickets created in the selected date range, per status
const LivechatTicketStatus = (props) => {
  const { selectedDepartment } = props;
  const [cookies] = useCookies(["user"]);
  const [startDate, setStartDate] = useState(new Date(moment().subtract(1, "months").format("YYYY-MM-DD")));
  const [endDate, setEndDate] = useState(new Date(moment().format("YYYY-MM-DD")));
  const [totals, setTotals] = useState({});
  const roleFunctions = getPermission()["dashboard"]?.access || [];

  const getData = async (start, end) => {
    const response = await getDashboardTicketStatusTotal(
      cookies.SIDikey,
      selectedDepartment.value,
      cookies.id,
      roleFunctions,
      start,
      end,
      "livechat",
    );
    const rows = Array.isArray(response.data) ? response.data : [];
    setTotals(Object.fromEntries(rows.map((row) => [row.status, row.total])));
  };

  useEffect(() => {
    getData(startDate, endDate);
  }, [selectedDepartment]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDate = ([start, end]) => {
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      getData(start, end);
    }
  };

  return (
    <Card className="card-full overflow-hidden">
      <div className="card-inner">
        <div className="card-title-group mb-3">
          <div className="card-title">
            <h6 className="title">Live Chat Ticket per Status</h6>
          </div>
          <div className="card-tools">
            <FormGroup className="mb-0" style={{ width: 212 }}>
              <label className="form-label">Select Date</label>
              <DatePicker
                className="form-control date-picker"
                selectsRange
                selected={startDate}
                startDate={startDate}
                endDate={endDate}
                onChange={handleDate}
                dateFormat={"yyyy-MM-dd"}
              />
            </FormGroup>
          </div>
        </div>
        <table className="table table-sm mb-0">
          <tbody>
            {STATUSES.map((status) => (
              <tr key={status}>
                <td>{status}</td>
                <td className="text-right">{totals[status] ?? 0}</td>
              </tr>
            ))}
            <tr className="font-weight-bold">
              <td>TOTAL</td>
              <td className="text-right">{STATUSES.reduce((sum, status) => sum + (totals[status] ?? 0), 0)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
};
export default LivechatTicketStatus;
